import { lazy } from "react"

export const FormTimeField = lazy(() =>
  import("./FormTimeField").then((module) => ({
    default: module.FormTimeField,
  })),
)
